import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-players-league-admin-view',
  templateUrl: './players-league-admin-view.component.html',
  styleUrls: ['./players-league-admin-view.component.scss']
})
export class PlayersLeagueAdminViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
